import React from 'react';
import { useApi } from '../hooks/useApi';
import { apiService } from '../services/api';

interface AlgemeneVoorwaardenData {
  title?: string;
  content?: string;
}

function AlgemeneVoorwaarden(): React.JSX.Element {
  const { data, loading, error } = useApi(apiService.getAlgemeneVoorwaarden);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '50vh',
        fontFamily: 'var(--font-body)'
      }}>
        Laden...
      </div>
    );
  }

  if (error || !data) {
    // Fallback content
    const fallbackData: AlgemeneVoorwaardenData = {
      title: 'Algemene voorwaarden',
      content: `
        <h2>Artikel 1 - Definities</h2>
        <p>In deze algemene voorwaarden wordt verstaan onder:</p>
        <ul>
          <li><strong>Hairmedics:</strong> de onderneming Hairmedics, gevestigd te Heiloo</li>
          <li><strong>Klant:</strong> de natuurlijke of rechtspersoon die een overeenkomst aangaat met Hairmedics</li>
          <li><strong>Behandeling:</strong> de door Hairmedics te verrichten diensten</li>
        </ul>

        <h2>Artikel 2 - Toepasselijkheid</h2>
        <p>Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, overeenkomsten en leveringen van Hairmedics.</p>

        <h2>Artikel 3 - Aanbiedingen en overeenkomsten</h2>
        <p>Alle aanbiedingen van Hairmedics zijn vrijblijvend en gelden voor de daarin vermelde periode. Een overeenkomst komt tot stand door aanvaarding van de aanbieding door de klant.</p>

        <h2>Artikel 4 - Uitvoering van de behandeling</h2>
        <p>Hairmedics zal de behandeling met de grootst mogelijke zorgvuldigheid uitvoeren en daarbij rekening houden met de wensen van de klant.</p>

        <h2>Artikel 5 - Betaling</h2>
        <p>Betaling dient te geschieden binnen 14 dagen na factuurdatum, tenzij anders overeengekomen.</p>

        <h2>Artikel 6 - Aansprakelijkheid</h2>
        <p>Hairmedics is slechts aansprakelijk voor schade die het gevolg is van opzet of grove schuld van haar kant.</p>

        <h2>Artikel 7 - Toepasselijk recht</h2>
        <p>Op alle overeenkomsten tussen Hairmedics en de klant is Nederlands recht van toepassing.</p>
      `
    };

    return (
      <section className="legal-page">
        <div className="legal-content">
          <h1 className="legal-title">{fallbackData.title}</h1>
          <div 
            className="legal-text"
            dangerouslySetInnerHTML={{ __html: fallbackData.content }}
          />
        </div>
      </section>
    );
  }

  const pageData = data as AlgemeneVoorwaardenData;

  return (
    <section className="legal-page">
      <div className="legal-content">
        <h1 className="legal-title">{pageData.title || 'Algemene voorwaarden'}</h1>
        <div 
          className="legal-text"
          dangerouslySetInnerHTML={{ __html: pageData.content || '' }}
        />
      </div>
    </section>
  );
}

export default AlgemeneVoorwaarden; 